import { useNavigate } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import Container from "./Components/Container";
import { API_BASE_URL } from "../../config/api";
import useInfinitePaginated from "../../hooks/useInfinitePaginated";

export default function NotificationAll() {
  const navigate = useNavigate();
  const { data: notif, initialLoading: accLoading, loadingMore, error, hasNext, sentinelRef, scrollRootRef, retry } =
    useInfinitePaginated({ endpoint: `${API_BASE_URL}notifications/announcements/?type=all`, navigate });
  return (
    <LayoutPage
      activeIndex={13}
      navItems={["اعلانات"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      {/* <NavLayer2
        texts={["همه", "مخصوص شما", "عمومی"]}
        hrefs={[
          "/notification/all",
          "/notification/for-you",
          "/notification/general",
        ]}
        activeIndex={0}
      /> */}
      <div className="w-full flex-1 min-h-0 flex flex-col items-center gap-5 overflow-hidden">
        <Container notif={notif} accLoading={accLoading} loadingMore={loadingMore} error={error} sentinelRef={sentinelRef} scrollRootRef={scrollRootRef} onRetry={retry} hasNext={hasNext} />
      </div>
    </LayoutPage>
  );
}
